module.exports = __webpack_public_path__ + "img/blue-shape.b199ca17.svg";